export const GE = () => {
  return (
    <>
      <g clipPath="url(#clip0_1073_11510)">
      <g clipPath="url(#clip1_1073_11510)">
      <rect width="96" height="96" fill="white"/>
      <rect x="40" width="16" height="96" fill="#EF4444"/>
      <rect x="96" y="40" width="16" height="96" transform="rotate(90 96 40)" fill="#EF4444"/>
      <circle cx="72" cy="24" r="8" fill="#EF4444"/>
      <circle cx="24" cy="24" r="8" fill="#EF4444"/>
      <circle cx="24" cy="72" r="8" fill="#EF4444"/>
      <circle cx="72" cy="72" r="8" fill="#EF4444"/>
      </g>
      </g>
      <rect x="2" y="2" width="92" height="92" rx="46" stroke="white" strokeOpacity="0.15" strokeWidth="4"/>
      <defs>
      <clipPath id="clip0_1073_11510">
      <rect width="96" height="96" rx="48" fill="white"/>
      </clipPath>
      <clipPath id="clip1_1073_11510">
      <rect width="96" height="96" rx="24" fill="white"/>
      </clipPath>
      </defs>
    </>
  )
}
